module.exports = __webpack_public_path__ + "img/edge_patrimoine_art_deco.5a76895e.svg";